import React from 'react';
import Buttons from '../Buttons';
import Heading from '../Heading';
import Pricelist from '../Pricelist';
import Sliders from '../Sliders';
import RichTextEditor from '../RichTextEditor';
import TwoColumns from '../TwoColumns';
import Contact from '../Contact';

function Content({elements}) {
  return (
    <>
      {elements?.map((content, index) => {
        const id = content.acf_fc_layout;
        if (id === "ElHeading") return <Heading key={id + index} content={content} />
        if (id === "ElSlider") return <Sliders key={id + index} content={content} />
        if (id === "El2Columns") return <TwoColumns key={id + index} content={content} />
        if (id === "ElPricelist") return <Pricelist key={id + index} content={content} />
        if (id === "ElButtons") return <Buttons key={id + index} content={content} />
        if (id === "ElRichTextEditor") return <RichTextEditor key={id + index} content={content} />
        if (id === "ElContact") return <Contact key={id + index} content={content} />
      })}
    </>
  );
}

export default Content;
